export default __webpack_public_path__ + "1b972674ca02e116225ac98417eb6d12.jpg";